// extracted by mini-css-extract-plugin
export var contentWrapper = "EventHighlightRightImage-module--contentWrapper--738d0";
export var image = "EventHighlightRightImage-module--image--92f3d";
export var imageWrapper = "EventHighlightRightImage-module--imageWrapper--c5c27";
export var mediaWrapper = "EventHighlightRightImage-module--mediaWrapper--80747";
export var wrapper = "EventHighlightRightImage-module--wrapper--1d7ab";